export type OS = "ios" | "android" | "windows" | "macos" | "chromeos" | "linux";

export function detectOs(): OS {
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/.test(ua)) return "ios";
  if (/Android/.test(ua)) return "android";
  if (/CrOS/.test(ua)) return "chromeos";
  if (/Mac OS X/.test(ua) && !/iPhone|iPad/.test(ua)) return "macos";
  if (/Linux/.test(ua)) return "linux";
  return "windows";
}
